export default __webpack_public_path__ + "static/media/life-labs.855a9295.svg";